import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingSeedreamAiImageGeneratorConfig } from '@/data/landingConfig/landingSeedreamAiImageGeneratorConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_SeedreamAiImageGenerator } from './schemaObject';

interface Props {}
const SeedreamAiImageGenerator: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_SeedreamAiImageGenerator} />
			<LandingTemplate
				data={landingSeedreamAiImageGeneratorConfig}
				funnelLinkService={GenerateLandingLinkService.funnelImageGeneratorV2()}
			/>
		</>
	);
};

export default SeedreamAiImageGenerator;
